import React, { useState, useEffect } from "react";
import Sidebar from "../../Components/Sidebar";
import TopNav from "../../Components/TopNav";
import {
  getCategoryServ,
  addCategoryServ,
  deleteCategoryServ,
  updateCategoryServ,
} from "../../services/category.service";
import {
  getBookingListServ,
  updateBookingServ,
} from "../../services/bookingDashboard.services";
import {
  getSupportDetailsServ,
  updateSupportDetailsServ,
} from "../../services/support.service";

import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import NoRecordFound from "../../Components/NoRecordFound";
function OrderList() {
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [statics, setStatics] = useState(null);
  const [payload, setPayload] = useState({
    searchKey: "",
    status: "",
    pageNo: 1,
    pageCount: 100,
    sortByField: "",
    sortByOrder: "dsc",
  });
  const [showSkelton, setShowSkelton] = useState(false);
  const handleGetBookingFunc = async () => {
    if (list.length == 0) {
      setShowSkelton(true);
    }
    try {
      let response = await getBookingListServ({ ...payload });
      setList(response?.data?.data);
      setStatics(response?.data?.documentCount);
    } catch (error) {}
    setShowSkelton(false);
  };
  const staticsArr = [
    {
      title: "Total Order",
      count: statics?.totalCount,
      bgColor: "#6777EF",
    },
    {
      title: "Completed Order",
      count: statics?.completed,
      bgColor: "#63ED7A",
    },
    {
      title: "Cancelled Order",
      count: statics?.cancelled,
      bgColor: "#FFA426",
    },
    
  ];
  useEffect(() => {
    handleGetBookingFunc();
  }, [payload]);
  const [isLoading, setIsLoading] = useState(false);

  const [editFormData, setEditFormData] = useState({
    status: "",
    _id: "",
    courierPartner: "",
    trackingNumber: "",
  });
  const handleUpdateOrderFunc = async () => {
    setIsLoading(true);

    try {
      let response = await updateBookingServ(editFormData);
      if (response?.data?.statusCode == "200") {
        toast.success(response?.data?.message);
        setEditFormData({
          status: "",
          _id: "",
          courierPartner: "",
          trackingNumber: "",
        });
        handleGetBookingFunc();
      }
    } catch (error) {
      toast.error("Internal Server Error");
    }
    setIsLoading(false);
  };
  const deliveryStatusOptions = [
    { label: "Select Delivery Status", value: "" },
    { label: "Order Placed", value: "orderPlaced" },
    { label: "Order Confirmed", value: "orderConfirmed" },
    { label: "Order Packed", value: "orderPacked" },
    { label: "Order Shipped", value: "shipped" },
    { label: "In Transit", value: "inTransit" },
    { label: "Order Delivered", value: "delivered" },
    { label: "Cancelled", value: "cancelled" },
  ];
  // includes legacy status values (outForDelivery, completed) so orders placed
  // before this status list changed still render a proper label
  const statusLabels = {
    orderPlaced: "Order Placed",
    orderConfirmed: "Order Confirmed",
    orderPacked: "Order Packed",
    shipped: "Order Shipped",
    inTransit: "In Transit",
    outForDelivery: "In Transit",
    delivered: "Order Delivered",
    completed: "Order Delivered",
    cancelled: "Cancelled",
  };
  const renderStatusFunction = (status) => statusLabels[status] || status;
  const [showUpdateDeliveryPopup, setShowUpdateDeliveryPopup] = useState(false);
  const [supportDetails, setSupportDetails] = useState({
    _id: "",
    deliveryCharge: "",
    minimumFreeOrderAmount: "",
  });
  const getSupportDetailsFunc = async () => {
    try {
      let response = await getSupportDetailsServ();
      if (response?.data?.statusCode == "200") {
        setSupportDetails({
          _id: response?.data?.data?._id,
          minimumFreeOrderAmount: response?.data?.data?.minimumFreeOrderAmount,
          deliveryCharge: response?.data?.data?.deliveryCharge,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getSupportDetailsFunc();
  }, []);
  const handleUpdateDeliverFunc = async () => {
    try {
      let response = await updateSupportDetailsServ(supportDetails);
      if (response?.data?.statusCode == "200") {
        toast.success(response?.data?.message);
        setSupportDetails({
          _id: "",
          minimumFreeOrderAmount: "",
          deliveryCharge: "",
        });
        getSupportDetailsFunc();
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div className="bodyContainer">
      <Sidebar selectedMenu="Orders" selectedItem="Orders" />
      <div className="mainContainer">
        <TopNav />
        <div className="p-lg-4 p-md-3 p-2">
          <div
            className="row mx-0 p-0"
            style={{
              position: "relative",
              top: "-75px",
              marginBottom: "-75px",
            }}
          >
            {staticsArr?.map((v, i) => {
              return (
                <div className="col-md-4 col-12 ">
                  <div className="topCard shadow-sm py-4 px-3 rounded mb-3">
                    <div className="d-flex align-items-center ">
                      <div
                        className="p-2 shadow rounded"
                        style={{ background: v?.bgColor }}
                      >
                        <img src="https://cdn-icons-png.flaticon.com/128/666/666120.png" />
                      </div>
                      <div className="ms-3">
                        <h6>{v?.title}</h6>
                        <h2 className="text-secondary">{v?.count}</h2>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="row m-0 p-0 d-flex justify-content-between align-items-center my-4 topActionForm">
            <div className="col-lg-4 mb-2 col-md-12 col-12">
              <h3 className="mb-0 text-bold text-secondary">Orders</h3>
            </div>
            <div className="col-lg-4 mb-2  col-md-6 col-12">
              <div>
                <select
                  className="form-control borderRadius24"
                  onChange={(e) =>
                    setPayload({ ...payload, status: e.target.value })
                  }
                >
                  {deliveryStatusOptions.map((status) => (
                    <option key={status.value} value={status.value}>
                      {status.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-lg-4 mb-2  col-md-6 col-12">
              <button
                className=" btn btn-primary shadow-sm w-100"
                onClick={() => setShowUpdateDeliveryPopup(true)}
                style={{ borderRadius: "24px" }}
              >
                Update Delivery Charge
              </button>
            </div>
          </div>
          <div className="mt-3">
            <div className="card-body px-2">
              {list?.map((v, i) => {
                return (
                  <div className="row px-2 pe-3 py-3 orderMainCard m-0 mb-4 shadow">
                    <div className="row col-6 m-0 p-0">
                      <div className="col-6 m-0">
                        <div className=" p-2 bg-light mb-2 boxCart">
                          <p>
                            <b>User Details</b>
                          </p>
                          <div className="d-flex align-items-center">
                            <div>
                              <img
                                src={
                                  v?.userId?.profilePic
                                    ? v?.userId?.profilePic
                                    : "https://cdn-icons-png.flaticon.com/128/149/149071.png"
                                }
                                style={{
                                  height: "50px",
                                  width: "50px",
                                  borderRadius: "50px",
                                }}
                              />
                            </div>
                            <div className="ms-2">
                              <p className="mb-0" style={{ fontSize: "14px" }}>
                                {v?.userId?.firstName +
                                  " " +
                                  v?.userId?.lastName}
                              </p>
                              <p className="mb-0" style={{ fontSize: "14px" }}>
                                Phone : {v?.userId?.phone}
                              </p>
                            </div>
                          </div>
                          <hr className="my-1" />
                          <p>
                            <b>Address</b>
                          </p>
                          <p>
                            {v?.address?.area}, {v?.address?.landmark},{" "}
                            {v?.address?.city}, {v?.address?.pincode},{" "}
                            {v?.address?.state}
                          </p>
                        </div>
                      </div>
                      <div className="col-6 m-0">
                        <div className=" p-2 bg-light boxCart">
                          <p>
                            <b>Order</b> : {v?._id?.substring(0, 10)}
                          </p>
                          <p>
                                <b>Deliver Charge</b>: ₹{v?.deliveryCharge || 0}
                              </p>
                          <p>
                            <b>Total Amount</b>: ₹{parseInt(v?.totalAmount || 0) + parseInt(v?.deliveryCharge || 0)}
                          </p>
                          <p>
                            <b>Status</b>: {renderStatusFunction(v?.status)}
                          </p>
                          <hr className="my-1" />
                          <p>
                            <b>Mode Of Payment</b> : {v?.modeOfPayment}
                          </p>
                          
                          {v?.modeOfPayment == "Online" && (
                            <>
                              <p>
                                <b>Signature</b>: {v?.signature}
                              </p>
                              <p>
                                <b>Payment ID</b>: {v?.paymentId}
                              </p>
                              <p>
                                <b>Order ID</b>: {v?.orderId}
                              </p>
                              
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-6 ">
                      {v?.product?.map((value, i) => {
                        return (
                          <div className=" ">
                            <div
                              className={
                                "flatCart d-flex row justify-content-between align-items-center  py-3 pb-4 " +
                                (i % 2 == 0
                                  ? "bg-light text-dark"
                                  : "text-light lightGreenBg")
                              }
                              style={{
                                marginTop: i * -10 + "px",
                                borderRadius:
                                  i + 1 == v?.product?.length
                                    ? "20px"
                                    : "20px 20px 0px 0px",
                              }}
                            >
                              <p className="col-1">{i + 1}.</p>

                              <p className="col-5">{value?.productId?.name}</p>
                              <p className="col-3">
                                Quantity : {value?.quantity}
                              </p>
                              <p className="col-3">
                                Total Price : {value?.totalPrice}
                              </p>
                            </div>
                          </div>
                        );
                      })}

                      {v?.comboProduct?.map((value, i) => {
                        return (
                          <div className=" ">
                            <div
                              className={
                                "flatCart d-flex row justify-content-between align-items-center  py-3 pb-4 " +
                                (i + (v?.product?.length % 2) == 0
                                  ? "bg-light text-dark"
                                  : "text-light lightGreenBg")
                              }
                              style={{
                                marginTop: i + v?.product?.length * -10 + "px",
                                borderRadius:
                                  i + v?.product?.length + 1 ==
                                  v?.product?.length + v?.comboProduct?.length
                                    ? "20px"
                                    : "20px 20px 0px 0px",
                              }}
                            >
                              <p className="col-1">
                                {i + v?.product?.length + 1}.
                              </p>

                              <p className="col-5">
                                {value?.comboProductId?.name}
                              </p>
                              <p className="col-3">
                                Quantity : {value?.quantity}
                              </p>
                              <p className="col-3">
                                Total Price : {value?.totalPrice}
                              </p>
                            </div>
                          </div>
                        );
                      })}
                      {v?.variantProduct?.map((value, i) => {
                        return (
                          <div className=" ">
                            <div
                              className={
                                "flatCart d-flex row justify-content-between align-items-center  py-3 pb-4 " +
                                ((i +
                                  v?.product?.length +
                                  v?.comboProduct?.length) %
                                  2 ==
                                0
                                  ? "bg-light text-dark"
                                  : "text-light lightGreenBg")
                              }
                              style={{
                                marginTop:
                                  (i +
                                    v?.product?.length +
                                    v?.comboProduct?.length) *
                                    -10 +
                                  "px",
                                borderRadius:
                                  i +
                                    v?.product?.length +
                                    v?.comboProduct?.length +
                                    1 ==
                                  v?.product?.length +
                                    v?.comboProduct?.length +
                                    v?.variantProduct?.length
                                    ? "20px"
                                    : "20px 20px 0px 0px",
                              }}
                            >
                              <p className="col-1">
                                {i +
                                  v?.product?.length +
                                  v?.comboProduct?.length +
                                  1}
                                .
                              </p>

                              <p className="col-5">
                                {value?.productId?.name} (
                                {
                                  value?.productId?.productVariants?.filter(
                                    (variant, i) => {
                                      return variant?._id == value?.variantId;
                                    }
                                  )[0]?.variantValue
                                }
                                )
                              </p>
                              <p className="col-3">
                                Quantity : {value?.quantity}
                              </p>
                              <p className="col-3">
                                Total Price : {value?.totalPrice}
                              </p>
                            </div>
                          </div>
                        );
                      })}
                    </div>

                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <button
                        className=" btn btn-light me-3 shadow-sm"
                        style={{ width: "250px" }}
                      >
                        Delivery Status : {renderStatusFunction(v?.status)}
                      </button>
                      <div>
                        <button
                          onClick={() => navigate("/order-details/" + v?._id)}
                          className="btn-info btn me-3 shadow-sm"
                          style={{ borderRadius: "24px", width: "200px" }}
                        >
                          View Details
                        </button>
                        <button
                          className="btn btn-success shadow-sm "
                          style={{ borderRadius: "24px", width: "200px" }}
                          onClick={() =>
                            setEditFormData({
                              status: v?.status,
                              _id: v?._id,
                              courierPartner: v?.courierPartner || "",
                              trackingNumber: v?.trackingNumber || "",
                            })
                          }
                        >
                          Update Status
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
              {list.length == 0 && !showSkelton && <NoRecordFound />}
            </div>
          </div>
        </div>
      </div>

      {editFormData?._id && (
        <div
          className="modal fade show d-flex align-items-center  justify-content-center "
          tabIndex="-1"
        >
          <div className="modal-dialog">
            <div
              className="modal-content"
              style={{
                borderRadius: "16px",
                background: "#f7f7f5",
                width: "364px",
              }}
            >
              <div className="d-flex justify-content-end pt-4 pb-0 px-4">
                <img
                  src="https://cdn-icons-png.flaticon.com/128/9068/9068699.png"
                  style={{ height: "20px" }}
                  onClick={() =>
                    setEditFormData({
                      status: "",
                      _id: "",
                      courierPartner: "",
                      trackingNumber: "",
                    })
                  }
                />
              </div>

              <div className="modal-body">
                <div
                  style={{
                    wordWrap: "break-word",
                    whiteSpace: "pre-wrap",
                  }}
                  className="d-flex justify-content-center w-100"
                >
                  <div className="w-100 px-2">
                    <h5 className="mb-4">Update Order Status</h5>
                    <label className="mt-3">Status</label>
                    <select
                      className="form-control borderRadius24"
                      onChange={(e) =>
                        setEditFormData({
                          ...editFormData,
                          status: e.target.value,
                        })
                      }
                      value={editFormData?.status}
                    >
                      {deliveryStatusOptions.map((status) => (
                        <option key={status.value} value={status.value}>
                          {status.label}
                        </option>
                      ))}
                    </select>

                    <label className="mt-3">Courier Partner</label>
                    <input
                      className="form-control borderRadius24"
                      placeholder="e.g. RQP Logistics"
                      value={editFormData?.courierPartner}
                      onChange={(e) =>
                        setEditFormData({
                          ...editFormData,
                          courierPartner: e.target.value,
                        })
                      }
                    />

                    <label className="mt-3">Tracking Number</label>
                    <input
                      className="form-control borderRadius24"
                      placeholder="e.g. MFDS1400457854"
                      value={editFormData?.trackingNumber}
                      onChange={(e) =>
                        setEditFormData({
                          ...editFormData,
                          trackingNumber: e.target.value,
                        })
                      }
                    />

                    {editFormData?.status ? (
                      <button
                        className="btn btn-success w-100 mt-4"
                        onClick={!isLoading && handleUpdateOrderFunc}
                      >
                        {isLoading ? "Saving..." : "Submit"}
                      </button>
                    ) : (
                      <button
                        className="btn btn-success w-100 mt-4"
                        style={{ opacity: "0.5" }}
                      >
                        Submit
                      </button>
                    )}
                  </div>
                </div>
                <div className="d-flex justify-content-center"></div>
              </div>
            </div>
          </div>
        </div>
      )}
      {editFormData?._id && <div className="modal-backdrop fade show"></div>}
      {showUpdateDeliveryPopup && (
        <div
          className="modal fade show d-flex align-items-center  justify-content-center "
          tabIndex="-1"
        >
          <div className="modal-dialog">
            <div
              className="modal-content"
              style={{
                borderRadius: "16px",
                background: "#f7f7f5",
                width: "364px",
              }}
            >
              <div className="d-flex justify-content-end pt-4 pb-0 px-4">
                <img
                  src="https://cdn-icons-png.flaticon.com/128/9068/9068699.png"
                  style={{ height: "20px" }}
                  onClick={() => setShowUpdateDeliveryPopup(false)}
                />
              </div>

              <div className="modal-body">
                <div
                  style={{
                    wordWrap: "break-word",
                    whiteSpace: "pre-wrap",
                  }}
                  className="d-flex justify-content-center w-100"
                >
                  <div className="w-100 px-2">
                    <h5 className="mb-4">Update Delivery Charge</h5>
                    <label className="mt-3">
                      Minimum Free Delivery Order Amount
                    </label>
                    <input
                      className="form-control"
                      value={supportDetails?.minimumFreeOrderAmount}
                      onChange={(e) =>
                        setSupportDetails({
                          ...supportDetails,
                          minimumFreeOrderAmount: e?.target.value,
                        })
                      }
                    />
                    <label className="mt-3">Delivery Charge</label>
                    <input
                      className="form-control"
                      value={supportDetails?.deliveryCharge}
                      onChange={(e) =>
                        setSupportDetails({
                          ...supportDetails,
                          deliveryCharge: e?.target.value,
                        })
                      }
                    />

                    {supportDetails?.minimumFreeOrderAmount &&
                    supportDetails?.deliveryCharge ? (
                      <button
                        className="btn btn-success w-100 mt-4"
                        onClick={!isLoading && handleUpdateDeliverFunc}
                      >
                        {isLoading ? "Saving..." : "Submit"}
                      </button>
                    ) : (
                      <button
                        className="btn btn-success w-100 mt-4"
                        style={{ opacity: "0.5" }}
                      >
                        Submit
                      </button>
                    )}
                  </div>
                </div>
                <div className="d-flex justify-content-center"></div>
              </div>
            </div>
          </div>
        </div>
      )}
      {showUpdateDeliveryPopup && (
        <div className="modal-backdrop fade show"></div>
      )}
    </div>
  );
}

export default OrderList;
